import { Point } from '@printu/geom';
export function toSegments(data) {
    if (!data || data.some(tuple => tuple.length !== 3)) {
        return null;
    }
    return data.map(([handleIn, point, handleOut]) => ({
        handleIn: new Point(handleIn),
        point: new Point(point),
        handleOut: new Point(handleOut),
    }));
}
export function createSegment(param0, handleIn, handleOut) {
    if (Array.isArray(param0)) {
        const coord = (index) => { var _a; return (_a = param0[index]) !== null && _a !== void 0 ? _a : 0; };
        const point = new Point(coord(0), coord(1));
        const lHandleIn = new Point(coord(2) - point.x, coord(3) - point.y);
        const lHandleOut = new Point(coord(4) - point.x, coord(5) - point.y);
        return {
            point,
            handleIn: lHandleIn,
            handleOut: lHandleOut,
        };
    }
    return {
        point: new Point(param0),
        handleIn: new Point(handleIn),
        handleOut: new Point(handleOut),
    };
}
export const transformSegment = (segment, matrix) => {
    const coords = getSegmentCoords(segment);
    matrix.transformCoordinates(coords, coords, coords.length);
    return createSegment(coords);
};
export const getSegmentCoords = (segment, coords) => {
    coords = coords !== null && coords !== void 0 ? coords : [];
    const { x, y } = segment.point;
    coords[0] = x;
    coords[1] = y;
    const { handleIn, handleOut } = segment;
    if (handleIn) {
        coords[2] = handleIn.x + x;
        coords[3] = handleIn.y + y;
    }
    if (handleOut) {
        coords[4] = handleOut.x + x;
        coords[5] = handleOut.y + y;
    }
    return coords;
};
